export default build =>
    build.query({
        tagTypes: ['subAgentsByAgent'],
        keepUnusedDataFor: 1,
        query(payload) {
            //console.log("payload",payload)            
            return {
                url: `/exam/getSubAgents`,
                method: 'GET',
               // body: payload,
            };
           
        },
       providesTags: ['subAgentsByAgent']
    })
